export const ConnectingStatus = {
  Connected: "connected",
  Failed: "Failed",
  Connecting: "Connecting",
};

export const CallReasonFor = {
  Repos: "Repos",
  Customer: "Customer",
  Insurance: "Insurance",
  Queues: "Queues",
  AMENDMENT: "AMENDMENT",
};

export const CallDirection = {
  Inbound: "Inbound",
  Outbound: "Outbound",
  NoCall: "",
};

export const CallFunctionalityUsed = {
  CallDialer: "CallDialer",
  SelectedCall: "SelectedCall",
  NoCalls: "NoCalls",
};
